module.exports = __webpack_public_path__ + "static/team3-a5c2dbf7405ce68fa9d6fc60d06f8961.jpg";